import { useInvalidateRefreshTokenMutation } from "@common/utils/graphql";
import { AUTH_ROUTES } from "@domains/auth/routes";
import { useAuthStore } from "@domains/auth/utils";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

export const SignOutPage = () => {
  const signOut = useAuthStore((state) => state.signOut);
  const refreshToken = useAuthStore((state) => state.refreshToken);
  const [invalidateRefreshToken] = useInvalidateRefreshTokenMutation();

  useEffect(() => {
    invalidateRefreshToken();
    signOut();
  }, [signOut, invalidateRefreshToken, refreshToken]);

  return <Navigate to={AUTH_ROUTES.LOGIN.path} />;
};
